/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface BestNodeResponse {
  webSocketUrl: string;
  id: string;
  apiUrl: string;
}

/**
 * @minLength 24
 * @maxLength 24
 * @example "6852d453a9674333e2b19fd1"
 */
export type ChannelId = string;

/**
 * @minLength 24
 * @maxLength 24
 * @example "7852d453a9674333e2b19fd2"
 */
export type AppId = string;

/**
 * @minLength 24
 * @maxLength 24
 * @example "8852d453a9674333e2b19fd3"
 */
export type PeerId = string;

/**
 * @minLength 24
 * @maxLength 100
 * @example "6890c002295ed3fac7f8ad58-audio-observer"
 */
export type DataProducerId = string;

/**
 * @format uuid
 * @pattern ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-4[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}$
 */
export type UuidV4 = string;

export type IceTransportPolicy = "all" | "relay";

export interface RegisteredPeerResponse {
  channelId: ChannelId;
  appId: AppId;
  /** The role of a participant in a channel. */
  role: Role;
  peerId: PeerId;
}

export type ProducerId = UuidV4;

export interface RtpCapabilities {
  codecs?: RtpCodecCapability[];
  headerExtensions?: RtpHeaderExtension[];
}

export interface RtcpFeedback {
  type: string;
  parameter?: string;
}

export interface RtpCodecCapability {
  kind: MediaKind;
  mimeType: string;
  /** @format int32 */
  preferredPayloadType?: number;
  /** @format int32 */
  clockRate: number;
  /** @format int32 */
  channels?: number;
  parameters?: Record<string, any>;
  rtcpFeedback?: RtcpFeedback[];
}

export type RtpHeaderExtensionUri = string;

export type RtpHeaderExtensionDirection = "sendrecv" | "sendonly" | "recvonly" | "inactive";

export interface RtpHeaderExtension {
  kind?: MediaKind;
  uri: RtpHeaderExtensionUri;
  preferredId?: number;
  preferredEncrypt?: boolean;
  direction?: RtpHeaderExtensionDirection;
}

export type TransportDirection = "receive" | "send";

export type AppData = Record<string, any>;

export type TransportOptions = object;

export interface IceParameters {
  usernameFragment: string;
  password: string;
  iceLite?: boolean;
}

export interface IceCandidate {
  foundation: string;
  priority: number;
  address: string;
  ip: string;
  protocol: "udp" | "tcp";
  port: number;
  type: "host" | "srflx" | "prflx" | "relay";
  tcpType?: "active" | "passive" | "so";
}

export type DtlsRole = "auto" | "client" | "server";

export type FingerprintAlgorithm = "sha-1" | "sha-224" | "sha-256" | "sha-384" | "sha-512";

export interface DtlsFingerprint {
  algorithm: FingerprintAlgorithm;
  value: string;
}

export interface DtlsParameters {
  role?: DtlsRole;
  fingerprints: DtlsFingerprint[];
}

export interface SctpParameters {
  port: number;
  OS: number;
  MIS: number;
  maxMessageSize: number;
}

export interface RtpEncodingParameters {
  active?: boolean;
  ssrc?: number;
  rid?: string;
  codecPayloadType?: number;
  rtx?: {
    ssrc: number;
  };
  dtx?: boolean;
  scalabilityMode?: string;
  scaleResolutionDownBy?: number;
  maxBitrate?: number;
  maxFramerate?: number;
  adaptivePtime?: boolean;
  priority?: "very-low" | "low" | "medium" | "high";
  networkPriority?: "very-low" | "low" | "medium" | "high";
}

export type MediaKind = "audio" | "video";

export interface ConsumerCreateResponse {
  id?: string;
  producerId?: ProducerId;
  kind?: MediaKind;
  rtpParameters: RtpParameters;
  streamId?: string;
  /** Reference to an OnRtpReceiverCallback */
  onRtpReceiver?: string;
  appData?: AppData;
  producerPaused: boolean;
}

export interface RtpParameters {
  mid?: string;
  msid?: string;
  codecs: RtpCodecParameters[];
  headerExtensions?: RtpHeaderExtensionParameters[];
  encodings?: RtpEncodingParameters[];
  rtcp?: RtcpParameters;
}

export interface RtcpParameters {
  cname?: string;
  reducedSize?: boolean;
  mux?: boolean;
}

export interface RtpHeaderExtensionParameters {
  uri: RtpHeaderExtensionUri;
  id: number;
  encrypt?: boolean;
  parameters?: Record<string, any>;
}

export interface RtpCodecParameters {
  mimeType: string;
  payloadType: number;
  clockRate: number;
  channels?: number;
  parameters?: Record<string, any>;
  rtcpFeedback?: RtcpFeedback[];
}

export type DataConsumerAppData = AppData & object;

export type TrackLabel =
  | "camera"
  | "microphone"
  | "screen-video"
  | "screen-audio"
  | "custom-video"
  | "custom-audio"
  | "unknown";

export interface SctpStreamParameters {
  streamId?: number;
  ordered?: boolean;
  maxPacketLifeTime?: number;
  maxRetransmits?: number;
  label?: string;
  protocol?: string;
}

export type TProducerAppData = AppData & {
  label: TrackLabel;
  keyFrameRequestDelay?: number;
  [key: string]: any;
};

export type TConsumerAppData = AppData & object;

export type DataProducerLabels = "consumers-scores";

export type PeerDataProducerLabels = "consumers-scores" | "channel-messages-data-producer" | "heart-beater";

export interface RTCIceServer {
  /** List of ICE server URLs (STUN/TURN). */
  urls: string[];
  /** Username for accessing the ICE server. */
  username: string;
  /** Credential (password or token) for the ICE server. */
  credential: string;
}

/** The role of a participant in a channel. */
export type Role = "audience" | "host";

/** A group to which a peer can belong. */
export type PeerGroup = "moderator" | "user";

/** Information about a peers in the channel. */
export interface PeersResponse {
  items: PeerItem[];
}

export interface ProducerItem {
  id: ProducerId;
  kind: MediaKind;
  label: TrackLabel;
  peerId: string;
  paused: boolean;
}

/** Information about a peer in the channel. */
export interface PeerItem {
  id: string;
  /** IDs of channels this peer is part of. */
  channelIds: string[];
  /** List of media producers created by this peer. */
  producers: ProducerItem[];
  nodeGrpcUrl: string;
  uid?: string;
  appId?: string;
  /** Arbitrary application data. */
  appData?: Record<string, any>;
  /** The role of a participant in a channel. */
  role: Role;
  /**
   * Timestamp when the peer logged in.
   * @format date-time
   */
  loginDate: string;
  /** Groups this peer belongs to. */
  groups: PeerGroup[];
  /** Which track labels this peer is allowed to produce. */
  producePermissions: TrackLabel[];
}

export interface ErrorResponse {
  /** @example "Validation failed" */
  error: string;
  /** @example "invalid_request" */
  errorCode:
    | "check_access_fail"
    | "join_room_fail"
    | "need_joined_to_channel"
    | "forbidden"
    | "not_found"
    | "invalid_request"
    | "already_created"
    | "too_many_requests"
    | "something_went_wrong"
    | "di_error"
    | "resources_lock_error"
    | "already_connected"
    | "timeout"
    | "unauthorized"
    | "canceled";
}

export namespace Peers {
  /**
   * No description
   * @tags peers
   * @name GetPeers
   * @summary Get list of peers joined the call (all or by role)
   * @request GET:/peers
   * @secure
   */
  export namespace GetPeers {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @default "host" */
      role?: Role;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = PeersResponse;
  }
  /**
   * No description
   * @tags peers
   * @name RegisterPeer
   * @summary Register peer in channel (join channel)
   * @request POST:/peers
   * @secure
   */
  export namespace RegisterPeer {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = {
      appData?: Record<string, any>;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = RegisteredPeerResponse;
  }
  /**
   * No description
   * @tags peers
   * @name DisconnectPeer
   * @summary Disconnect peer from channel
   * @request DELETE:/peers
   * @secure
   */
  export namespace DisconnectPeer {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags peers
   * @name ChangePeerProducePermissions
   * @summary Add possibility to produce some media with specified track labels
   * @request PUT:/peers/{peerId}/produce-permissions
   * @secure
   */
  export namespace ChangePeerProducePermissions {
    export type RequestParams = {
      /** ID of peer */
      peerId: PeerId;
    };
    export type RequestQuery = {};
    export type RequestBody = {
      /** Which track labels this peer is allowed to produce. */
      producePermissions?: TrackLabel[];
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags peers
   * @name AddPeerProducePermissions
   * @summary Add possibility to produce some media with specified track label
   * @request POST:/peers/{peerId}/produce-permissions/{track-label}
   * @secure
   */
  export namespace AddPeerProducePermissions {
    export type RequestParams = {
      /** ID of peer */
      peerId: PeerId;
      /** Track label */
      trackLabel: TrackLabel;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags peers
   * @name RemovePeerProducePermissions
   * @summary Remove possibility to produce some media with specified track label
   * @request DELETE:/peers/{peerId}/produce-permissions/{track-label}
   * @secure
   */
  export namespace RemovePeerProducePermissions {
    export type RequestParams = {
      /** ID of peer */
      peerId: PeerId;
      /** Track label */
      trackLabel: TrackLabel;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
}

export namespace Router {
  /**
   * No description
   * @tags router
   * @name GetRtpCapabilities
   * @summary Get RTP capabilities
   * @request GET:/router/rtp-capabilities
   * @secure
   */
  export namespace GetRtpCapabilities {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      rtpCapabilities: RtpCapabilities;
    };
  }
}

export namespace Channel {
  /**
   * No description
   * @tags channel
   * @name ConfirmChannelActivity
   * @summary Reset auto destruction timer for active call
   * @request PATCH:/channel/activity
   * @secure
   */
  export namespace ConfirmChannelActivity {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags channel
   * @name TriggerChannelStateEvent
   * @summary Request the current state of peers on the server and the id of this event
   * @request GET:/channel/peers-state-message-id
   * @secure
   */
  export namespace TriggerChannelStateEvent {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @default "host" */
      role?: Role;
    };
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      /** @format int32 */
      messageId?: number;
    };
  }
}

export namespace Ping {
  /**
   * No description
   * @tags ping
   * @name PingPeer
   * @summary Some ping endpoint
   * @request POST:/ping
   * @secure
   */
  export namespace PingPeer {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = "Pong";
  }
}

export namespace AppData {
  /**
   * No description
   * @tags appData
   * @name UpdateSelfPeerAppData
   * @summary Update self peer application data
   * @request PUT:/app-data
   * @secure
   */
  export namespace UpdateSelfPeerAppData {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = {
      appData: Record<string, any>;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
}

export namespace Producer {
  /**
   * No description
   * @tags producer
   * @name GetGeneralDataProducer
   * @summary Get general data producer
   * @request GET:/producer/general-data
   * @secure
   */
  export namespace GetGeneralDataProducer {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      producerId: DataProducerId;
    };
  }
  /**
   * No description
   * @tags producer
   * @name GetAudioObserverProducer
   * @summary Get audio observer producer
   * @request GET:/producer/audio-observer
   * @secure
   */
  export namespace GetAudioObserverProducer {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      producerId: DataProducerId;
    };
  }
  /**
   * No description
   * @tags producer
   * @name GetChannelStateSyncDataProducer
   * @summary Get channel state sync data producer
   * @request GET:/producer/channel-state-sync-data
   * @secure
   */
  export namespace GetChannelStateSyncDataProducer {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      producerId: DataProducerId;
    };
  }
  /**
   * No description
   * @tags producer
   * @name CloseProducer
   * @summary Close a producer
   * @request DELETE:/producer/{producerId}
   * @secure
   */
  export namespace CloseProducer {
    export type RequestParams = {
      /** ID of media producer */
      producerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags producer
   * @name PauseProducer
   * @summary Pause a producer
   * @request POST:/producer/{producerId}/actions/pause
   * @secure
   */
  export namespace PauseProducer {
    export type RequestParams = {
      /** ID of media producer */
      producerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags producer
   * @name ResumeProducer
   * @summary Resume a producer
   * @request POST:/producer/{producerId}/actions/resume
   * @secure
   */
  export namespace ResumeProducer {
    export type RequestParams = {
      /** ID of media producer */
      producerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags producer
   * @name RequestProducerMaxSpatialLayer
   * @summary Request producer max spatial layer
   * @request POST:/producer/{producerId}/max-spatial-layer
   * @secure
   */
  export namespace RequestProducerMaxSpatialLayer {
    export type RequestParams = {
      /** ID of media producer */
      producerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = {
      /** @format int32 */
      spatialLayer: number;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags producer
   * @name SetProducerMaxSpatialLayer
   * @summary Set producer max spatial layer
   * @request PUT:/producer/{producerId}/max-spatial-layer
   * @secure
   */
  export namespace SetProducerMaxSpatialLayer {
    export type RequestParams = {
      /** ID of media producer */
      producerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = {
      /** @format int32 */
      maxSpatialLayer: number;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
}

export namespace Consumer {
  /**
   * No description
   * @tags consumer
   * @name CreateConsumer
   * @summary Create a consumer
   * @request POST:/consumer
   * @secure
   */
  export namespace CreateConsumer {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = {
      producerId: ProducerId;
      transportId: UuidV4;
      rtpCapabilities: RtpCapabilities;
      appData?: TConsumerAppData;
      producerPeerId: PeerId;
      /** Force close existing consumer with matching identifiers before creating a new one. */
      forceCloseExisting?: boolean;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      id?: string;
      producerId?: ProducerId;
      kind?: MediaKind;
      rtpParameters: RtpParameters;
      streamId?: string;
      /** Reference to an OnRtpReceiverCallback */
      onRtpReceiver?: string;
      appData?: AppData;
      producerPaused: boolean;
    };
  }
  /**
   * No description
   * @tags consumer
   * @name CloseConsumer
   * @summary Close a consumer
   * @request DELETE:/consumer/{consumerId}
   * @secure
   */
  export namespace CloseConsumer {
    export type RequestParams = {
      /** ID of media consumer */
      consumerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags consumer
   * @name PauseConsumer
   * @summary Pause a consumer
   * @request POST:/consumer/{consumerId}/actions/pause
   * @secure
   */
  export namespace PauseConsumer {
    export type RequestParams = {
      /** ID of media consumer */
      consumerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags consumer
   * @name ResumeConsumer
   * @summary Resume a consumer
   * @request POST:/consumer/{consumerId}/actions/resume
   * @secure
   */
  export namespace ResumeConsumer {
    export type RequestParams = {
      /** ID of media consumer */
      consumerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags consumer
   * @name UpdateConsumerPreferredLayers
   * @summary Change consumer preferred layers
   * @request PUT:/consumer/{consumerId}/preferred-layers
   * @secure
   */
  export namespace UpdateConsumerPreferredLayers {
    export type RequestParams = {
      /** ID of media consumer */
      consumerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = {
      /** @format int32 */
      spatialLayer: number;
      /** @format int32 */
      temporalLayer?: number;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags consumer
   * @name RequestConsumerKeyFrame
   * @summary Request a key frame
   * @request POST:/consumer/{consumerId}/key-frame
   * @secure
   */
  export namespace RequestConsumerKeyFrame {
    export type RequestParams = {
      /** ID of media consumer */
      consumerId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
}

export namespace DataConsumer {
  /**
   * No description
   * @tags dataConsumer
   * @name CreateDataConsumer
   * @summary Create a data consumer
   * @request POST:/data-consumer
   * @secure
   */
  export namespace CreateDataConsumer {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = {
      dataProducerId: DataProducerId;
      transportId: UuidV4;
      appData?: DataConsumerAppData;
      ordered?: boolean;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      id?: string;
      dataProducerId?: string;
      sctpStreamParameters: SctpStreamParameters;
      label?: string;
      protocol?: string;
      appData?: AppData;
    };
  }
}

export namespace Transport {
  /**
   * No description
   * @tags transport
   * @name CreateTransport
   * @summary Create a transport
   * @request POST:/transport
   * @secure
   */
  export namespace CreateTransport {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = {
      localDirection: TransportDirection;
      tcpOnly?: boolean;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      id: string;
      iceParameters: IceParameters;
      iceCandidates: IceCandidate[];
      dtlsParameters: DtlsParameters;
      sctpParameters?: SctpParameters;
      iceServers?: RTCIceServer[];
      iceTransportPolicy?: IceTransportPolicy;
      appData?: AppData;
    };
  }
  /**
   * No description
   * @tags transport
   * @name GetTransportIceParameters
   * @summary Get ICE parameters
   * @request GET:/transport/{transportId}/ice-parameters
   * @secure
   */
  export namespace GetTransportIceParameters {
    export type RequestParams = {
      /** ID of media transport */
      transportId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      iceParameters: IceParameters;
    };
  }
  /**
   * No description
   * @tags transport
   * @name ConnectTransport
   * @summary Connect a transport (DTLS)
   * @request PUT:/transport/{transportId}/connect
   * @secure
   */
  export namespace ConnectTransport {
    export type RequestParams = {
      /** ID of media transport */
      transportId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = {
      dtlsParameters: DtlsParameters;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
  /**
   * No description
   * @tags transport
   * @name ProduceMediaToTransport
   * @summary Produce media over transport
   * @request PUT:/transport/{transportId}/media-producer
   * @secure
   */
  export namespace ProduceMediaToTransport {
    export type RequestParams = {
      /** ID of media transport */
      transportId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = {
      kind: MediaKind;
      rtpParameters: RtpParameters;
      appData: TProducerAppData;
      /** Force close existing producer with matching identifiers before creating a new one. */
      forceCloseExisting?: boolean;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      id: string;
    };
  }
  /**
   * No description
   * @tags transport
   * @name ProduceDataToTransport
   * @summary Produce data over transport
   * @request PUT:/transport/{transportId}/data-producer
   * @secure
   */
  export namespace ProduceDataToTransport {
    export type RequestParams = {
      /** ID of media transport */
      transportId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = {
      label: PeerDataProducerLabels;
      sctpStreamParameters?: SctpStreamParameters;
      appData?: DataConsumerAppData;
    };
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = {
      id: string;
    };
  }
  /**
   * No description
   * @tags transport
   * @name CloseTransport
   * @summary Close transport
   * @request DELETE:/transport/{transportId}
   * @secure
   */
  export namespace CloseTransport {
    export type RequestParams = {
      /** ID of media transport */
      transportId: UuidV4;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {
      /**
       * Peer API version
       * @format int32
       * @min 1
       * @example 1
       */
      "x-peer-api-version"?: number;
      /**
       * Data center type - for p2p or common calls
       * @default "common"
       */
      "x-datacenter-type"?: "p2p" | "common";
      /** Preferred data center name for the initial channel assignment */
      "x-datacenter-name"?: string;
    };
    export type ResponseBody = void;
  }
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "signaling.livedigital.space/v1" });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Signaling API
 * @version 1.0.0
 * @baseUrl signaling.livedigital.space/v1
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  peers = {
    /**
     * No description
     *
     * @tags peers
     * @name GetPeers
     * @summary Get list of peers joined the call (all or by role)
     * @request GET:/peers
     * @secure
     */
    getPeers: (
      query?: {
        /** @default "host" */
        role?: Role;
      },
      params: RequestParams = {},
    ) =>
      this.request<PeersResponse, ErrorResponse>({
        path: `/peers`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags peers
     * @name RegisterPeer
     * @summary Register peer in channel (join channel)
     * @request POST:/peers
     * @secure
     */
    registerPeer: (
      data: {
        appData?: Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<RegisteredPeerResponse, ErrorResponse>({
        path: `/peers`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags peers
     * @name DisconnectPeer
     * @summary Disconnect peer from channel
     * @request DELETE:/peers
     * @secure
     */
    disconnectPeer: (params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/peers`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags peers
     * @name ChangePeerProducePermissions
     * @summary Add possibility to produce some media with specified track labels
     * @request PUT:/peers/{peerId}/produce-permissions
     * @secure
     */
    changePeerProducePermissions: (
      peerId: PeerId,
      data: {
        /** Which track labels this peer is allowed to produce. */
        producePermissions?: TrackLabel[];
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/peers/${peerId}/produce-permissions`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags peers
     * @name AddPeerProducePermissions
     * @summary Add possibility to produce some media with specified track label
     * @request POST:/peers/{peerId}/produce-permissions/{track-label}
     * @secure
     */
    addPeerProducePermissions: (peerId: PeerId, trackLabel: TrackLabel, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/peers/${peerId}/produce-permissions/${trackLabel}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags peers
     * @name RemovePeerProducePermissions
     * @summary Remove possibility to produce some media with specified track label
     * @request DELETE:/peers/{peerId}/produce-permissions/{track-label}
     * @secure
     */
    removePeerProducePermissions: (peerId: PeerId, trackLabel: TrackLabel, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/peers/${peerId}/produce-permissions/${trackLabel}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
  router = {
    /**
     * No description
     *
     * @tags router
     * @name GetRtpCapabilities
     * @summary Get RTP capabilities
     * @request GET:/router/rtp-capabilities
     * @secure
     */
    getRtpCapabilities: (params: RequestParams = {}) =>
      this.request<
        {
          rtpCapabilities: RtpCapabilities;
        },
        ErrorResponse
      >({
        path: `/router/rtp-capabilities`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  channel = {
    /**
     * No description
     *
     * @tags channel
     * @name ConfirmChannelActivity
     * @summary Reset auto destruction timer for active call
     * @request PATCH:/channel/activity
     * @secure
     */
    confirmChannelActivity: (params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/channel/activity`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags channel
     * @name TriggerChannelStateEvent
     * @summary Request the current state of peers on the server and the id of this event
     * @request GET:/channel/peers-state-message-id
     * @secure
     */
    triggerChannelStateEvent: (
      query?: {
        /** @default "host" */
        role?: Role;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          /** @format int32 */
          messageId?: number;
        },
        ErrorResponse
      >({
        path: `/channel/peers-state-message-id`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  ping = {
    /**
     * No description
     *
     * @tags ping
     * @name PingPeer
     * @summary Some ping endpoint
     * @request POST:/ping
     * @secure
     */
    pingPeer: (params: RequestParams = {}) =>
      this.request<"Pong", ErrorResponse>({
        path: `/ping`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  appData = {
    /**
     * No description
     *
     * @tags appData
     * @name UpdateSelfPeerAppData
     * @summary Update self peer application data
     * @request PUT:/app-data
     * @secure
     */
    updateSelfPeerAppData: (
      data: {
        appData: Record<string, any>;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/app-data`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  producer = {
    /**
     * No description
     *
     * @tags producer
     * @name GetGeneralDataProducer
     * @summary Get general data producer
     * @request GET:/producer/general-data
     * @secure
     */
    getGeneralDataProducer: (params: RequestParams = {}) =>
      this.request<
        {
          producerId: DataProducerId;
        },
        ErrorResponse
      >({
        path: `/producer/general-data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags producer
     * @name GetAudioObserverProducer
     * @summary Get audio observer producer
     * @request GET:/producer/audio-observer
     * @secure
     */
    getAudioObserverProducer: (params: RequestParams = {}) =>
      this.request<
        {
          producerId: DataProducerId;
        },
        ErrorResponse
      >({
        path: `/producer/audio-observer`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags producer
     * @name GetChannelStateSyncDataProducer
     * @summary Get channel state sync data producer
     * @request GET:/producer/channel-state-sync-data
     * @secure
     */
    getChannelStateSyncDataProducer: (params: RequestParams = {}) =>
      this.request<
        {
          producerId: DataProducerId;
        },
        ErrorResponse
      >({
        path: `/producer/channel-state-sync-data`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags producer
     * @name CloseProducer
     * @summary Close a producer
     * @request DELETE:/producer/{producerId}
     * @secure
     */
    closeProducer: (producerId: UuidV4, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/producer/${producerId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags producer
     * @name PauseProducer
     * @summary Pause a producer
     * @request POST:/producer/{producerId}/actions/pause
     * @secure
     */
    pauseProducer: (producerId: UuidV4, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/producer/${producerId}/actions/pause`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags producer
     * @name ResumeProducer
     * @summary Resume a producer
     * @request POST:/producer/{producerId}/actions/resume
     * @secure
     */
    resumeProducer: (producerId: UuidV4, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/producer/${producerId}/actions/resume`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags producer
     * @name RequestProducerMaxSpatialLayer
     * @summary Request producer max spatial layer
     * @request POST:/producer/{producerId}/max-spatial-layer
     * @secure
     */
    requestProducerMaxSpatialLayer: (
      producerId: UuidV4,
      data: {
        /** @format int32 */
        spatialLayer: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/producer/${producerId}/max-spatial-layer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags producer
     * @name SetProducerMaxSpatialLayer
     * @summary Set producer max spatial layer
     * @request PUT:/producer/{producerId}/max-spatial-layer
     * @secure
     */
    setProducerMaxSpatialLayer: (
      producerId: UuidV4,
      data: {
        /** @format int32 */
        maxSpatialLayer: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/producer/${producerId}/max-spatial-layer`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  consumer = {
    /**
     * No description
     *
     * @tags consumer
     * @name CreateConsumer
     * @summary Create a consumer
     * @request POST:/consumer
     * @secure
     */
    createConsumer: (
      data: {
        producerId: ProducerId;
        transportId: UuidV4;
        rtpCapabilities: RtpCapabilities;
        appData?: TConsumerAppData;
        producerPeerId: PeerId;
        /** Force close existing consumer with matching identifiers before creating a new one. */
        forceCloseExisting?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id?: string;
          producerId?: ProducerId;
          kind?: MediaKind;
          rtpParameters: RtpParameters;
          streamId?: string;
          /** Reference to an OnRtpReceiverCallback */
          onRtpReceiver?: string;
          appData?: AppData;
          producerPaused: boolean;
        },
        ErrorResponse
      >({
        path: `/consumer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags consumer
     * @name CloseConsumer
     * @summary Close a consumer
     * @request DELETE:/consumer/{consumerId}
     * @secure
     */
    closeConsumer: (consumerId: UuidV4, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/consumer/${consumerId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags consumer
     * @name PauseConsumer
     * @summary Pause a consumer
     * @request POST:/consumer/{consumerId}/actions/pause
     * @secure
     */
    pauseConsumer: (consumerId: UuidV4, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/consumer/${consumerId}/actions/pause`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags consumer
     * @name ResumeConsumer
     * @summary Resume a consumer
     * @request POST:/consumer/{consumerId}/actions/resume
     * @secure
     */
    resumeConsumer: (consumerId: UuidV4, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/consumer/${consumerId}/actions/resume`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags consumer
     * @name UpdateConsumerPreferredLayers
     * @summary Change consumer preferred layers
     * @request PUT:/consumer/{consumerId}/preferred-layers
     * @secure
     */
    updateConsumerPreferredLayers: (
      consumerId: UuidV4,
      data: {
        /** @format int32 */
        spatialLayer: number;
        /** @format int32 */
        temporalLayer?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/consumer/${consumerId}/preferred-layers`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags consumer
     * @name RequestConsumerKeyFrame
     * @summary Request a key frame
     * @request POST:/consumer/{consumerId}/key-frame
     * @secure
     */
    requestConsumerKeyFrame: (consumerId: UuidV4, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/consumer/${consumerId}/key-frame`,
        method: "POST",
        secure: true,
        ...params,
      }),
  };
  dataConsumer = {
    /**
     * No description
     *
     * @tags dataConsumer
     * @name CreateDataConsumer
     * @summary Create a data consumer
     * @request POST:/data-consumer
     * @secure
     */
    createDataConsumer: (
      data: {
        dataProducerId: DataProducerId;
        transportId: UuidV4;
        appData?: DataConsumerAppData;
        ordered?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id?: string;
          dataProducerId?: string;
          sctpStreamParameters: SctpStreamParameters;
          label?: string;
          protocol?: string;
          appData?: AppData;
        },
        ErrorResponse
      >({
        path: `/data-consumer`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  transport = {
    /**
     * No description
     *
     * @tags transport
     * @name CreateTransport
     * @summary Create a transport
     * @request POST:/transport
     * @secure
     */
    createTransport: (
      data: {
        localDirection: TransportDirection;
        tcpOnly?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: string;
          iceParameters: IceParameters;
          iceCandidates: IceCandidate[];
          dtlsParameters: DtlsParameters;
          sctpParameters?: SctpParameters;
          iceServers?: RTCIceServer[];
          iceTransportPolicy?: IceTransportPolicy;
          appData?: AppData;
        },
        ErrorResponse
      >({
        path: `/transport`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport
     * @name GetTransportIceParameters
     * @summary Get ICE parameters
     * @request GET:/transport/{transportId}/ice-parameters
     * @secure
     */
    getTransportIceParameters: (transportId: UuidV4, params: RequestParams = {}) =>
      this.request<
        {
          iceParameters: IceParameters;
        },
        ErrorResponse
      >({
        path: `/transport/${transportId}/ice-parameters`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport
     * @name ConnectTransport
     * @summary Connect a transport (DTLS)
     * @request PUT:/transport/{transportId}/connect
     * @secure
     */
    connectTransport: (
      transportId: UuidV4,
      data: {
        dtlsParameters: DtlsParameters;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse>({
        path: `/transport/${transportId}/connect`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport
     * @name ProduceMediaToTransport
     * @summary Produce media over transport
     * @request PUT:/transport/{transportId}/media-producer
     * @secure
     */
    produceMediaToTransport: (
      transportId: UuidV4,
      data: {
        kind: MediaKind;
        rtpParameters: RtpParameters;
        appData: TProducerAppData;
        /** Force close existing producer with matching identifiers before creating a new one. */
        forceCloseExisting?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: string;
        },
        ErrorResponse
      >({
        path: `/transport/${transportId}/media-producer`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport
     * @name ProduceDataToTransport
     * @summary Produce data over transport
     * @request PUT:/transport/{transportId}/data-producer
     * @secure
     */
    produceDataToTransport: (
      transportId: UuidV4,
      data: {
        label: PeerDataProducerLabels;
        sctpStreamParameters?: SctpStreamParameters;
        appData?: DataConsumerAppData;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        {
          id: string;
        },
        ErrorResponse
      >({
        path: `/transport/${transportId}/data-producer`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags transport
     * @name CloseTransport
     * @summary Close transport
     * @request DELETE:/transport/{transportId}
     * @secure
     */
    closeTransport: (transportId: UuidV4, params: RequestParams = {}) =>
      this.request<void, ErrorResponse>({
        path: `/transport/${transportId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),
  };
}
